import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Provider as DisabledProvider } from '../../context/disabled';
import useForm from '../../hooks/form/useForm';
import { Provider } from '../../stream/context';
import { useFieldDefaultValue } from '../utils';
export const COMPONENT_NAME = 'Form';
const createForm = (slice, sliceDeprecated)=>{
    const Form = /*#__PURE__*/ memo((inProps)=>{
        const props = useFieldDefaultValue({
            slice,
            sliceDeprecated,
            inProps,
            name: COMPONENT_NAME
        });
        const { apm, apmActionTransformer, children, formDescriptorFn, name, initialFormData, enableReinitialize, debug, disabled, streamExtension } = props;
        const { formStream$ } = useForm({
            formDescriptorFn,
            initialFormData,
            name,
            enableReinitialize,
            debug,
            apm,
            apmActionTransformer,
            disabled
        }, streamExtension);
        return /*#__PURE__*/ React.createElement(Provider, {
            value: formStream$
        }, /*#__PURE__*/ React.createElement(DisabledProvider, {
            value: disabled
        }, children));
    });
    Form.displayName = 'Form';
    Form.propTypes = {
        apm: PropTypes.bool,
        apmActionTransformer: PropTypes.func,
        children: PropTypes.node,
        debug: PropTypes.bool,
        disabled: PropTypes.bool,
        enableReinitialize: PropTypes.bool,
        formDescriptorFn: PropTypes.func,
        initialFormData: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.func
        ]),
        name: PropTypes.string,
        streamExtension: PropTypes.object
    };
    return Form;
};
export default createForm;
